import { createSlice } from '@reduxjs/toolkit'
import { get } from 'lodash'
import { CONFIGURED_SERVICE_TABS_ID } from 'containers/configured-service/settings'

const { DETAILS_PRICING_TAB_ID } = CONFIGURED_SERVICE_TABS_ID

const configuredServiceDetailsSlice = createSlice({
  name: 'configuredServiceDetails',
  initialState: {
    currentTab: DETAILS_PRICING_TAB_ID,
    headerActionMenu: {
      isEditServiceDialogOpen: false,
      isDeactivateServiceDialogOpen: false,
    },
  },
  reducers: {
    onChangeTab: (state, action) => {
      state.currentTab = action.payload
    },
    setIsEditServiceDialogOpen: (state, action) => {
      state.headerActionMenu = {
        ...state.headerActionMenu,
        isEditServiceDialogOpen: action.payload,
      }
    },
    setIsDeactivateServiceDialogOpen: (state, action) => {
      state.headerActionMenu = {
        ...state.headerActionMenu,
        isDeactivateServiceDialogOpen: action.payload,
      }
    },
  },
})

export const { onChangeTab, setIsEditServiceDialogOpen, setIsDeactivateServiceDialogOpen } = configuredServiceDetailsSlice.actions

export const selectIsEditServiceDialogOpen = s => get(s, 'configuredServiceDetails.headerActionMenu.isEditServiceDialogOpen', false)
export const selectIsDeactivateServiceDialogOpen = s =>
  get(s, 'configuredServiceDetails.headerActionMenu.isDeactivateServiceDialogOpen', false)

export default configuredServiceDetailsSlice.reducer
